module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.infoTitle))]), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.info.infoDt)))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.infoDesc)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6dfd0d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inews_con.vue
// module id = 822
// module chunks = 10